import React, { useEffect } from 'react';
import { Typography, Box, Paper, Grid, Divider } from '@mui/material';

const AboutPage: React.FC = () => {
  useEffect(() => {
    // Update the document title
    document.title = 'Hakkımızda - Akademi Kadro';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Akademi Kadro hakkında bilgi edinin. Misyonumuz, vizyonumuz ve değerlerimiz.');
    }
    
    // Clean up when component unmounts
    return () => {
      document.title = 'Akademi Kadro - Güncel Haberler';
      if (metaDescription) {
        metaDescription.setAttribute('content', 'Akademi Kadro - Güncel haberler, son dakika gelişmeleri, ekonomi, siyaset, spor, eğitim ve kültür haberleri');
      }
    };
  }, []);

  return (
    <Box sx={{ py: { xs: 3, md: 5 } }}>
      <Paper elevation={3} sx={{ p: { xs: 3, sm: 4, md: 6 }, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', fontSize: { xs: '1.75rem', md: '2.125rem' } }}>
          Hakkımızda
        </Typography>
        <Divider sx={{ mb: { xs: 3, md: 5 } }} />
        
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' }, gap: { xs: 3, md: 6 } }}>
          <Box>
            <Typography variant="body1" paragraph>
              Akademi Kadro, 2023 yılında kurulan ve Türkiye'nin en güvenilir haber kaynaklarından biri olmayı hedefleyen bir haber portalıdır. Okuyucularımıza doğru, tarafsız ve hızlı habercilik hizmeti sunmayı amaçlıyoruz.
            </Typography>
            
            <Typography variant="body1" paragraph>
              Tecrübeli ve profesyonel ekibimiz ile Türkiye ve dünya gündemini yakından takip ederek, en güncel haberleri sizlere ulaştırıyoruz. Haber kategorilerimiz arasında gündem, ekonomi, spor, teknoloji, kültür-sanat, sağlık, eğitim ve daha birçok alanda içerikler sunmaktayız.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
              Misyonumuz
            </Typography>
            <Typography variant="body1" paragraph>
              Doğru ve güvenilir habercilik ilkesiyle hareket ederek, okuyucularımızı bilgilendirmek, bilinçlendirmek ve güncel gelişmelerden haberdar etmektir. Habercilikte etik değerlere sadık kalarak, toplumsal sorumluluğumuzun bilincinde bir yayın politikası izliyoruz.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
              Vizyonumuz
            </Typography>
            <Typography variant="body1" paragraph>
              Türkiye'nin lider haber portalı olmak ve uluslararası standartlarda habercilik yaparak küresel arenada da yer almaktır. Teknolojik gelişmeleri yakından takip ederek, okuyucularımıza en iyi kullanıcı deneyimini sunmayı hedefliyoruz.
            </Typography>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>
              Değerlerimiz
            </Typography>
            <Box component="ul" sx={{ pl: { xs: 1, md: 2 }, mt: 1 }}>
              <Typography component="li" variant="body1" paragraph>
                <strong>Doğruluk:</strong> Her haberi teyit ederek, yanıltıcı bilgilerden kaçınmak.
              </Typography>
              <Typography component="li" variant="body1" paragraph>
                <strong>Tarafsızlık:</strong> Olayları herhangi bir siyasi veya ideolojik çerçeveye hapsetmeden aktarmak.
              </Typography>
              <Typography component="li" variant="body1" paragraph>
                <strong>Şeffaflık:</strong> Haber kaynakları ve süreçler konusunda açık olmak.
              </Typography>
              <Typography component="li" variant="body1" paragraph>
                <strong>İnsan odaklılık:</strong> İnsan haklarına saygı duyan ve toplumsal duyarlılığı yüksek habercilik yapmak.
              </Typography>
              <Typography component="li" variant="body1" paragraph>
                <strong>Yenilikçilik:</strong> Teknoloji ve habercilikteki yenilikleri takip ederek sürekli gelişmek.
              </Typography>
            </Box>
          </Box>
          
          <Box sx={{ mt: { xs: 3, md: 0 } }}>
            <Box sx={{ bgcolor: 'background.paper', p: { xs: 2, md: 3 }, borderRadius: 2 }}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                İletişim Bilgilerimiz
              </Typography>
              <Typography variant="body2" paragraph>
                <strong>Adres:</strong> Çankaya/Ankara
              </Typography>
    
              <Typography variant="body2" paragraph>
                <strong>E-posta:</strong> akademikadro@gmail.com
              </Typography>
              
              <Divider sx={{ my: 2 }} />
              
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                Reklam ve İş Birliği
              </Typography>
              <Typography variant="body2">
                Reklam ve iş birliği talepleriniz için lütfen <strong> akademikadro@gmail.com</strong> adresine e-posta gönderiniz.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default AboutPage; 